import React from 'react'
import { motion } from 'framer-motion'
const AnimatedButton = ({children}) => {
  return (
    <motion.div

  whileTap={{ scale: 1.1 }}  
         
>
 {children}
</motion.div>
  )
}

export default AnimatedButton
